/**
 * Offers the resource at `url` for download, with the suggested
 * `filename`.
 *
 * This is a workaround for `<a download>`, as the latter only works for
 * same-origin URLs.
 *
 * Note that this buffers the file content in memory before offering the
 * download prompt; a better idea, where possible, is to create a GCS
 * signed URL with `responseDisposition` set to
 * `attachment; filename="<filename>"`
 */
export async function offerDownload(
    url: string,
    filename: string
): Promise<void> {
    const response = await fetch(url);
    const blob = await response.blob();
    const objectURL = URL.createObjectURL(blob);

    const link = document.createElement('a');
    link.href = objectURL;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    setTimeout(() => URL.revokeObjectURL(objectURL), 0);
}
